import { render, staticRenderFns } from "./coffer.vue?vue&type=template&id=e7ae6bec&scoped=true"
import script from "./coffer.vue?vue&type=script&lang=js"
export * from "./coffer.vue?vue&type=script&lang=js"
import style0 from "./coffer.vue?vue&type=style&index=0&id=e7ae6bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ae6bec",
  null
  
)

export default component.exports